const FETCH_DEDUCTIONS = 'fetch_deductions';
const FETCH_DEDUCTION = 'fetch_deduction';
const DELETE_DEDUCTION = 'delete_deduction';
const PERSIST_DEDUCTION = 'persist_deduction';
export default {
    FETCH_DEDUCTIONS,
    FETCH_DEDUCTION,
    DELETE_DEDUCTION,
    PERSIST_DEDUCTION,
};
